import type { Prototype } from "../prototype-types";

export const yanwuGuPrototypes: Prototype[] = [
  {
    id: "yg-ads-manager-profit-calculator",
    name: "Ads Manager Profit Calculator",
    path: "/yg/ads-manager-profit-calculator",
    description:
      "Profit calculator prototype on the Promoted Listings overview dashboard",
    owner: "Yanwu Gu",
    createdAt: "2026-06-09",
    lastUpdated: "2026-06-09",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/e923c95d9597fe2ed396edbdb1adfbfd4c77b534869cdf03492e8e7dd127517e.png",
    creationTool: "claude-code",
  },
];
